/* bm_peakExplorer_map.js – Map-Init, Controls, Resize, Marker */
(function () {
  window.BM = window.BM || {};
  if (window.BM.__peakExplorerMapLoaded) return;
  window.BM.__peakExplorerMapLoaded = true;

  const DEFAULT_STYLE = 'mapbox://styles/mapbox/outdoors-v12';
  const SLOW_CONNECTION_TYPES = Object.freeze(['slow-2g', '2g', '3g']);

  function initMap(mapEl, center, rectColor, initialStyle = DEFAULT_STYLE) {
    if (!mapEl || !Array.isArray(center) || center.length < 2) return null;
    if (typeof mapboxgl === 'undefined' || typeof mapboxgl.supported !== 'function') return null;
    if (!mapboxgl.supported()) return null;

    let map = null;
    let marker = null;
    let resizeObserver = null;
    let windowResizeHandler = null;

    try {
      map = new mapboxgl.Map({
        container: mapEl,
        style: typeof initialStyle === 'string' && initialStyle ? initialStyle : DEFAULT_STYLE,
        center,
        zoom: 11.2,
        pitch: 60,
        bearing: -20,
        antialias: true,
        projection: 'globe',
        minZoom: 2,
        maxZoom: 16
      });

      const effectiveType = navigator.connection?.effectiveType || '';
      const isSlowConnection = SLOW_CONNECTION_TYPES.includes(effectiveType);
      if (typeof map.setPrefetchZoomDelta === 'function') {
        map.setPrefetchZoomDelta(isSlowConnection ? 0 : 1);
      }

      map.addControl(new mapboxgl.NavigationControl({ showCompass: true }), 'top-right');
      map.addControl(new mapboxgl.ScaleControl({ unit: 'metric' }));

      const resizeMap = () => {
        const bounds = mapEl.getBoundingClientRect();
        if (bounds.width > 0 && bounds.height > 0) map.resize();
      };
      const scheduleResize = window.BM.util?.rafThrottle?.(resizeMap) || resizeMap;

      if (typeof ResizeObserver === 'function') {
        resizeObserver = new ResizeObserver(scheduleResize);
        resizeObserver.observe(mapEl);
      } else {
        windowResizeHandler = scheduleResize;
        window.addEventListener('resize', windowResizeHandler, { passive: true });
      }

      const rootEl = mapEl.closest('.bm-custom-peak');
      const pinUrl = rootEl?.dataset?.pinUrl;

      if (pinUrl) {
        const pin = document.createElement('img');
        pin.src = pinUrl;
        pin.alt = '';
        pin.className = 'bm-pin';
        pin.draggable = false;
        pin.addEventListener('error', () => {
          pin.removeAttribute('src');
          pin.classList.add('bm-pin--fallback');
        }, { once: true });

        marker = new mapboxgl.Marker({ element: pin, anchor: 'bottom', draggable: true })
          .setLngLat(center)
          .addTo(map);
      } else {
        marker = new mapboxgl.Marker({ color: rectColor || '#253545', draggable: true })
          .setLngLat(center)
          .addTo(map);
      }

      function cleanupMapKit() {
        resizeObserver?.disconnect();
        resizeObserver = null;

        if (windowResizeHandler) {
          window.removeEventListener('resize', windowResizeHandler);
          windowResizeHandler.cancel?.();
          windowResizeHandler = null;
        } else {
          scheduleResize.cancel?.();
        }
      }

      function setCenterAndRedraw(lngLat, fit = false, onRedraw) {
        marker.setLngLat(lngLat);
        const nextCenter = [lngLat.lng ?? lngLat[0], lngLat.lat ?? lngLat[1]];
        onRedraw?.(nextCenter, fit);
      }

      return { map, marker, setCenterAndRedraw, cleanup: cleanupMapKit };
    } catch {
      resizeObserver?.disconnect();
      if (windowResizeHandler) window.removeEventListener('resize', windowResizeHandler);
      try {
        map?.remove?.();
      } catch {
        // Mapbox kann nach einer unvollständigen Konstruktion bereits entfernt sein.
      }
      return null;
    }
  }

  window.BM.initMap = initMap;
})();
